import React from 'react';

interface EmbedContentRendererProps {
  payload: {
    url: string;
  };
}

export const EmbedContentRenderer: React.FC<EmbedContentRendererProps> = ({ payload }) => {
  return (
    <div className="text-center">
      <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-8 mb-4">
        <div className="text-4xl mb-4">🔗</div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-2">
          Nội dung nhúng
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4 break-all">
          {payload.url}
        </p>
        <a
          href={payload.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
          Mở liên kết
        </a>
      </div>
    </div>
  );
};
